import Nri from './Nri'

export default Nri
